import { Component, Host, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'spw-tooltip',
  styleUrl: 'spw-tooltip.scss',
  shadow: true,
})
export class SpwTooltip {
  /** Titre du tooltip */
  @Prop() tooltipTitle: string = '';
  /** Texte du tooltip */
  @Prop() tooltipText: string = '';
  /** Positionnement du tooltip */
  @Prop() direction: 'top' | 'bottom' | 'left' | 'right' = 'top';

  @State() isVisible: boolean = false;

  private showTooltip = () => {
    this.isVisible = true;
  };

  private hideTooltip = () => {
    this.isVisible = false;
  };

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-tooltip__content': true,
      [`spw-tooltip__content--${this.direction}`]: true,
    };
  }

  render() {
    return (
      <Host>
        <div class="spw-tooltip__container" onMouseEnter={this.showTooltip} onMouseLeave={this.hideTooltip}>
          <slot></slot>
          {this.isVisible && (
            <div class={this.elementClass} role="tooltip">
              {this.tooltipTitle && <strong class="spw-tooltip__title">{this.tooltipTitle}</strong>}
              {this.tooltipText && this.tooltipText}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
